module.exports = __webpack_public_path__ + "img/check_color.9b01c05f.png";